
<app-status-bar></app-status-bar>

<!-- Router Component -->
<div class="app-content">
  <router-outlet></router-outlet> 
</div> 
